declare namespace $ {

	export class $bog_tooltip_plugin extends $mol_plugin {
	}
	
}

//# sourceMappingURL=tooltip.view.tree.d.ts.map